<template>
  <div class="case_banner">
    <div>
      <img src="../../assets/case.jpg" />
      <div class="wenan">
        <div class="wen_title">解决方案</div>
        <div class="wen_content">
          以满足客户流程数字化管控+智慧物联场景建设需求为核心 <br />
          帮助制造企业实现供应敏捷化、制造柔性化、产品个性化、决策智能化
        </div>
      </div>
    </div>
  </div>
  <div class="cass_video">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>视频</span>
            <span class="red">案例</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">CASEVEDIO</div>
      </div>
      <div class="video_content flex">
        <div
          v-for="item in videos"
          :key="item.id"
          :style="{ width: (inner_width - 10) / 4 - 2 + 'px' }"
          class="video_box"
        >
          <div
            class="video_item"
            @click="openVideo(item)"
            :style="{
              width: inner_width / 4 - 20 + 'px',
            }"
          >
            <div class="header" style="position: relative">
              <video v-if="item.path" v-bind:src="item.path" class="video-avatar videoyl">
                您的浏览器不支持视频播放
              </video>
              <img v-else src="../../assets/wutup.jpg" />
              <img
                src="../../assets/bof.png"
                style="position: absolute; left: 35%; top: 20%; width: 100px;opacity:0.7"
              />
            </div>

            <div class="video_item_title">
              {{ item.title }}
            </div>
            <div class="video_item_content">
              {{ item.content }}
            </div>
          </div>
          <el-button
            v-if="this.isZ"
            type="danger"
            style="position: absolute; top: 0%; right: 2%; width: 5px; height: 5px"
            @click="deleteVideo(item)"
            circle
          ></el-button>
        </div>
        <div
          v-if="this.isZ"
          :style="{ width: (inner_width - 10) / 4 - 10 + 'px' }"
          class="video_box"
        >
          <div class="video_item_split"></div>
          <div class="video_item" @click="openVideo()">
            <img style="height: 100%; width: 100%" src="../../assets/addbig.png" />
          </div>
        </div>
      </div>
      <el-dialog v-model="videoVisible" :title="this.videoTitle" width="60%">
        <div>
          <el-form :model="videoFrom" ref="videoFrom">
            <el-form-item prop="file">
              <el-upload
                v-model="videoFrom.file"
                :limit="1"
                :on-preview="handlePreview"
                :before-upload="beforeUpload"
                :data="this.fileData"
                action="kekon/caseVedio"
                class="avatar-uploader"
                accept=".mp4,.ogg,.flv,.avi,.wmv,.rmvb,.mov"
              >
                <video
                  v-if="this.fileData.id"
                  v-bind:src="this.fileData.path"
                  class="video-avatar"
                  controls="controls"
                  controlslist="nodownload"
                  autoplay
                  muted
                  loop
                >
                  您的浏览器不支持视频播放
                </video>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item prop="title">
              <el-input v-model="videoFrom.title" placeholder="请输入标题" />
            </el-form-item>
            <el-form-item prop="content">
              <el-input
                v-model="videoFrom.content"
                type="textarea"
                :rows="5"
                placeholder="请输入简介"
              />
            </el-form-item>
          </el-form>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="videoVisible = false">取消</el-button>
            <el-button type="primary" @click="submitVideo()">确认提交</el-button>
          </span>
        </template>
      </el-dialog>
      <el-dialog v-model="videoDoVisible" width="70%" top="7vh" style="background: #000">
        <div
          style="
            width: 100%;
            height: 0;
            padding-bottom: 56.25%;
            position: relative;
            background: #000;
          "
        >
          <video
            v-if="this.fileData.id"
            v-bind:src="this.fileData.path"
            class="video-avatar videoyll"
            controls="controls"
            controlslist="nodownload"
            autoplay
            muted
            loop
          >
            您的浏览器不支持视频播放
          </video>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import axios from "axios";
import SparkMD5 from "spark-md5";
import { v4 as uuid4v } from "uuid";
export default {
  data() {
    return {
      videoDoVisible: false,
      videoVisible: false,
      store: useStore(),
      isZ: false,
      videoTitle: "",
      inner_width: 1920,
      videos: [],
      videoFrom: {
        title: "",
        content: "",
        file: "",
      },
      videoFromDto: {
        title: "",
        content: "",
        path: "",
      },
      fileData: {
        id: "",
        path: "",
        oldFileId: "",
        oldPath: "",
      },
      path: "",
      MD5: "",
    };
  },
  mounted() {
    const user = this.store.state.userInfo;
    this.isZ = user ? (user.permission ? user.permission == 0 : false) : false;
    this.inner_width = document.querySelector(".inner").offsetWidth;

    this.queryVideo();
  },
  methods: {
    queryVideo() {
      axios
        .get("/caseVedio/query", {
          params: { status: this.isZ ? "" : 1 },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            // ElMessage.success("数据获取成功");
            this.videos = response.data.data;
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    openVideo(item) {
      if (item) {
        this.videoDoVisible = true;
        this.videoFromDto.title = item.title;
        this.videoFromDto.content = item.content;
        this.attachNo = item.attachNo;
        this.videoFromDto.path = item.path;
        this.videoFromDto.attachmentId = item.attachmentId;
        this.fileData.id = item.attachmentId;
        this.fileData.path = item.path;
      } else {
        if (this.isZ) {
          this.videoVisible = true;
          this.videoFromDto = {};
          this.fileData.id = "";
          this.fileData.path = "";
          this.attachNo = uuid4v();
        }
      }
    },
    submitVideo() {
      // this.$refs[Ref].validate((valid) => {
      //   if (valid) {
      if (!this.fileData.id) {
        ElMessage.error("视频文件不能为空！");
        return;
      }
      const videoDto = {
        id: this.id,
        status: 1,
        title: this.videoFrom.title,
        attachmentId: this.fileData.id,
        content: this.videoFrom.content,
        attachNo: this.attachNo,
      };
      // 提交数据到接口
      axios
        .post("/caseVedio/save", videoDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.videoVisible = false;
            this.queryVideo();
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("视频上传失败", error);
        });
      //   } else {
      //     ElMessage.error("请填写所有必填项");
      //   }
      // });
    },
    async beforeUpload(file) {
      if (!file) {
        this.$message.error("文件丢失取消上传");
        return false;
      } else if (file.size / 1024 / 1024 > 50) {
        this.$message.error("文件不能大雨50M");
        return false;
      }
      try {
        var fileReader = new FileReader();
        //获取文件二进制数据
        fileReader.readAsArrayBuffer(file);
        const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = async (e) => {
          spark.append(e.target.result);
          this.MD5 = spark.end();
          this.localUpload(file, this.MD5);
        };
      } catch (error) {
        console.error("计算MD5值有误：", error);
        return false;
      }
      return false;
    },
    //上传文件到本地服务器
    localUpload(file, MD5) {
       const fileType=file.name.split('.')[1];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("md5", MD5);
      formData.append("category", "case");
      formData.append("size", file.size);
      formData.append("originalName", file.name);
      formData.append("type", fileType);
      formData.append("method", 0);
      formData.append("attachNo", this.attachNo);
      formData.append("oldId", this.fileData.oldFileId);
      formData.append("oldPath", this.fileData.oldPath);
      formData.append("id", this.fileData.id);
      // formData.append("finner", this.schemeItem.sno);
      formData.append("status", 0);
      formData.append("subcategory", "video");
      // 提交数据到接口
      axios
        .post("/attachment/localUpload", formData, {
          Headers: {
            "Content-Type": "multipart/form-data",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.fileData.id = response.data.data.id;
            this.fileData.oldFileId = response.data.data.id;
            this.fileData.path = response.data.data.path;
            this.fileData.oldPath = response.data.data.path;
          } else {
            ElMessage.error("提交失败：" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    deleteVideo(item) {
      this.$confirm("此操作将移除该视频, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const videoDto = {
            id: item.id,
            attachmentId: item.attachmentId,
            path: item.path,
            attachNo: item.attachNo,
          };
          // 提交数据到接口
          axios
            .post("/caseVedio/delete", videoDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.queryVideo();
              } else {
                ElMessage.error("视频失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("痛点移除失败", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消移除该产品痛点",
          });
        });
    },
  },
};
</script>
<style>
.cass_video {
  margin-top: 30px;
}
.video_box {
  position: relative; /* 设置父元素为相对定位 */
  margin-bottom: 30px;
  display: flex;
}
.video_content {
  flex-wrap: wrap;
}
.video_content .video_item {
  background: #f8f8f8;
  border-radius: 3px;
  border: 2px solid #efefef;
  cursor: pointer;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  padding: 2px;
  padding-bottom: 5px;
}
.video_content .video_item:hover {
  box-shadow: 0 0 10px 5px rgba(41, 148, 248, 0.3);
}
.videoyl {
  /* max-width: 92%;
  max-height: 92%; */
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  position: absolute;
}
.videoyll {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  position: absolute;
}
.video_item .header {
  left: 2%;
  height: 0;
  width: 96%;
  padding-bottom: 56.25%;
  position: relative;
}
.video_item_title {
  font-size: 20px;
  font-weight: 700;
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
}
.video_item_content {
  font-size: 16px;
  padding-left: 20px;
}
</style>
